import type { NavigationGuardNext } from "vue-router";

export default async function requireAuth({ next, authStore }: { next: NavigationGuardNext; authStore: any }) {
  try {
    const user = authStore.user;

    if (!user) {
      return next({ name: "Login" });
    }
  } catch (error) {
    document.location.href = "/login";
  }

  return next();
}
